import React from "react";

import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";

import BatchDetail from "../../../common/BatchDetail";
import useAxios from "../../../../hooks/useAxios";
import useAlert from "../../../../hooks/useAlert";
import { changeNumberColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import {
  __getChangeNumber,
  __changeNumberSelectelRecheck,
} from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "status",
  "trial_count",
  "zipcode",
  "old_msisdn",
  "new_msisdn",
  "last_updated",
];

const RecheckButton = ({ batch_id }) => {
  const { setAlertMessage } = useAlert();
  const [recheckResponse, recheckCall, recheckLoading] = useAxios({
    ...__changeNumberSelectelRecheck,
  });

  React.useEffect(() => {
    if (recheckResponse && recheckResponse.status) {
      setAlertMessage({
        type: "success",
        message: "Change number recheck queued",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recheckResponse]);

  return (
    <Grid item sx={{ mb: "10px" }}>
      <Button
        variant="contained"
        color="primary"
        disabled={recheckLoading}
        onClick={() => recheckCall({ params: { batch_id: batch_id } })}
      >
        Recheck Status
      </Button>
    </Grid>
  );
};

const SelectelChangeNumberBatch = () => (
  <BatchDetail
    title="Change Number"
    apiGet={__getChangeNumber}
    client={CLIENTS.selectel}
    columnsFactory={changeNumberColumns}
    copyKeys={COPY_KEYS}
    exportAction="change_number"
    retryOperation="change_number"
    showTerminate
    getRowPath={(row) => `/selectel/change_number/${row.id}`}
    extraActions={({ batch_id }) => <RecheckButton batch_id={batch_id} />}
  />
);

export default SelectelChangeNumberBatch;
